import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  selectThemeMode,
  setThemeMode,
  ThemeMode,
} from "../../../../../redux/features/theme/theme-slice";
import BackArrowButton from "../../../ui-elements/back-arrow-button/back-arrow-button";
import MaterialIcon, {
  MtIcon,
} from "../../../ui-elements/material-icon/material-icon";
import styles from "./theme-details.module.scss";

interface IThemeCardProps {
  mode: ThemeMode;
  icon: MtIcon;
  label: string;
  isActive: boolean;
  onClick: (mode: ThemeMode) => void;
}

const ThemeCard = ({
  mode,
  icon,
  label,
  isActive,
  onClick,
}: IThemeCardProps) => {
  return (
    <div className={`${styles.themeCard} w-100`} onClick={() => onClick(mode)}>
      <div className="d-flex flex-column justify-content-between h-100">
        <MaterialIcon icon={icon} size={32} color="#7483CC" fill />
        <span className="text-dark font-weight-500 font-size-16">{label}</span>
      </div>
      {isActive && (
        <div className="d-flex align-items-center">
          <MaterialIcon
            icon="check_circle"
            size={24}
            color="var(--primary)"
            fill={true}
          />
        </div>
      )}
    </div>
  );
};

const ThemeDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const themeMode = useSelector(selectThemeMode);

  const handleThemeChange = (mode: ThemeMode) => {
    dispatch(setThemeMode(mode));
  };

  return (
    <div className="w-100">
      <BackArrowButton onBack={() => navigate(-1)} />
      <Row className="g-4 mt-3">
        <Col xs={12} sm={6} lg={4} xl={3}>
          <ThemeCard
            mode="dark"
            icon="dark_mode"
            label="Dark Mode"
            isActive={themeMode === "dark"}
            onClick={handleThemeChange}
          />
        </Col>
        <Col xs={12} sm={6} lg={4} xl={3}>
          <ThemeCard
            mode="light"
            icon="light_mode"
            label="Light Mode"
            isActive={themeMode === "light"}
            onClick={handleThemeChange}
          />
        </Col>
        <Col xs={12} sm={6} lg={4} xl={3}>
          <ThemeCard
            mode="system"
            icon="desktop_windows"
            label="System Default"
            isActive={themeMode === "system"}
            onClick={handleThemeChange}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ThemeDetails;
